import React from 'react'

import {
  ScrollMobileBar,
  ScrollMobileDots,
  ScrollMobileButtonLeft,
  ScrollMobileButtonRight

} from './Scroller.styles'

import ScrollMobileDotContainer from './ScrollerMobileDot.container'

import { Icon } from '../../../shared/tr-icons'

const ScrollerMobileComponent = ({ events, currCol, scrollHandle, headers }) => {
  return (
    <div>
      <ScrollMobileButtonLeft onClick={events.handleScrollLeftClick}>
        <Icon type='caretUp' />
      </ScrollMobileButtonLeft>
      <ScrollMobileDots>
        {
          headers.map((header, i) => {
            return (
              <ScrollMobileDotContainer key={'dot' + i} handleScrollDotClick={events.handleScrollDotClick} active={currCol === i} dotNumber={i} />
            )
          })
        }
      </ScrollMobileDots>
      <ScrollMobileButtonRight onClick={events.handleScrollRightClick}>
        <Icon type='caretUp' />
      </ScrollMobileButtonRight>

      <ScrollMobileBar>
        {scrollHandle}
      </ScrollMobileBar>
    </div>
  )
}

export default ScrollerMobileComponent
